<template>
  <div :style="{height:formDivHeight+'px',overflow: 'auto'}">
    <el-form :model="tenantForm" :rules="formRules" label-position="right" ref="tenantForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="企业编号" prop="tenantPid">
        <el-input v-model="tenantForm.tenantPid" style="width: 98%" placeholder="输入企业编号"></el-input>
      </el-form-item>
      <el-form-item label="企业名称" prop="tenantName">
        <el-input v-model="tenantForm.tenantName" style="width: 98%" placeholder="输入企业名称"></el-input>
      </el-form-item>
      <el-form-item label="联 系 人" prop="tenantPeople">
        <el-input v-model="tenantForm.tenantPeople" style="width: 98%" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="thephone">
        <el-input v-model="tenantForm.thephone" style="width: 98%" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="tenantAddress">
        <el-input v-model="tenantForm.tenantAddress" style="width: 98%" placeholder="请输入联系地址"></el-input>
      </el-form-item>
      <el-form-item label="单位公章" prop="companySeal">
        <el-upload class="seal-uploader" action="#" :show-file-list="false" :before-upload="beforeCompanySealUpload" :http-request="handleCompanySealUpload" accept="image/*">
          <div v-if="companySealPreviewUrl" class="seal-preview">
            <img :src="companySealPreviewUrl" class="seal-image" alt="单位公章">
            <div class="seal-overlay">
              <i class="el-icon-zoom-in" @click.stop="previewCompanySeal"></i>
              <i class="el-icon-delete" @click.stop="removeCompanySeal"></i>
            </div>
          </div>
          <div v-else class="seal-upload-placeholder">
            <i class="el-icon-plus seal-uploader-icon"></i>
            <div class="seal-uploader-text">上传单位公章</div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="检测专用章" prop="inspectionSeal">
        <el-upload class="seal-uploader" action="#" :show-file-list="false" :before-upload="beforeInspectionSealUpload" :http-request="handleInspectionSealUpload" accept="image/*">
          <div v-if="inspectionSealPreviewUrl" class="seal-preview">
            <img :src="inspectionSealPreviewUrl" class="seal-image" alt="检测专用章">
            <div class="seal-overlay">
              <i class="el-icon-zoom-in" @click.stop="previewInspectionSeal"></i>
              <i class="el-icon-delete" @click.stop="removeInspectionSeal"></i>
            </div>
          </div>
          <div v-else class="seal-upload-placeholder">
            <i class="el-icon-plus seal-uploader-icon"></i>
            <div class="seal-uploader-text">上传检测专用章</div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input v-model="tenantForm.remarks" type="textarea" :rows="3" style="width: 98%" placeholder="请输入备注信息" maxlength="500" show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: center">
      <el-button type="primary" style="width: 100px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
      <el-button type="danger" style="width: 100px" @click="closeWindow()">关闭</el-button>
    </div>
    <el-dialog title="文件预览" size="55%" :visible.sync="isview" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="viewFileName"></PdfImgViewer>
    </el-dialog>
  </div>
</template>
<script>
import PdfImgViewer from "@/components/pdfview/PdfImgViewer.vue";
import { appjs } from "@/utiljs/apputil";
export default {
  components: {
    PdfImgViewer
  },
  props: {
    closeWindow: {
      type: Function
    }
  },
  data () {
    return {
      formDivHeight: 530,
      saveButValue: '保 存',
      saveButState: false,
      isview: false,
      viewFileName: '',
      companySealPreviewUrl: '',
      inspectionSealPreviewUrl: '',
      tenantForm: {
        tenantName: '',
        tenantPid: '',
        tenantPeople: '',
        thephone: '',
        tenantAddress: '',
        companySeal: '',
        inspectionSeal: '',
        remarks: ''
      },
      formRules: {
        tenantName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        tenantPid: [
          { required: true, message: '请输入企业编号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resertForm () {
      this.saveButValue = '保 存';
      this.saveButState = false;
      this.$refs['tenantForm'].resetFields();
    },
    submitForm () {
      this.$refs.tenantForm.validate((valid) => {
        if (valid) {
          let params = this.tenantForm;
          this.saveButValue = '保存中....'
          this.saveButState = true;
          let _self = this;
          appjs.httpRequest('tenant/saveTenant', params).then((data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.showErrorMsg(data.retMsg);
              _self.saveButValue = '保存';
              _self.saveButState = false;
            } else {
              _self.saveButValue = '保存成功';
              _self.closeWindow(data.retMsg);
            }
          }).catch((error) => {
            _self.saveButState = false;
            _self.loginText = '保存';
            appjs.showErrorMsg("异常：" + error)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 单位公章上传前验证
    beforeCompanySealUpload (file) {
      const isImage = file.type.startsWith('image/');
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 单位公章上传处理
    handleCompanySealUpload (fileData) {
      var _self = this;
      var formdata = new FormData();
      formdata.append("file", fileData.file);
      var name = fileData.file.name;
      var type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);
      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        console.log('单位公章上传进度:', ((event.loaded / event.total) * 100).toFixed(0) + "%");
      }).then((data) => {
        if (data.retCode === "ok") {
          fileData.onSuccess();
          // 优先使用 fileName，如果没有则使用 retMsg
          const fileUUID = data.fileName || data.retMsg;
          _self.tenantForm.companySeal = fileUUID;
          _self.companySealPreviewUrl = '/api/imgs/' + fileUUID;
          appjs.showSuccessMsg("上传成功");
        } else {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg || "上传失败");
        }
      }).catch((error) => {
        fileData.onError();
        appjs.showErrorMsg("异常：" + error)
      })
    },
    // 预览单位公章
    previewCompanySeal () {
      if (this.tenantForm.companySeal) {
        this.viewFileName = this.tenantForm.companySeal;
        this.isview = true;
        this.$nextTick(() => {
          if (this.$refs['pdfImgViewer']) {
            this.$refs['pdfImgViewer'].init();
          }
        });
      }
    },
    // 删除单位公章
    removeCompanySeal () {
      this.$confirm('确定要删除单位公章吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tenantForm.companySeal = '';
        this.companySealPreviewUrl = '';
        this.$message.success('删除成功');
      }).catch(() => { });
    },
    // 检测专用章上传前验证
    beforeInspectionSealUpload (file) {
      const isImage = file.type.startsWith('image/');
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 检测专用章上传处理
    handleInspectionSealUpload (fileData) {
      var _self = this;
      var formdata = new FormData();
      formdata.append("file", fileData.file);
      var name = fileData.file.name;
      var type = name.substring(name.lastIndexOf(".") + 1);
      formdata.append("fileType", type);
      appjs.httpRequest('fileupload', formdata, "fileupload", function (event) {
        console.log('检测专用章上传进度:', ((event.loaded / event.total) * 100).toFixed(0) + "%");
      }).then((data) => {
        if (data.retCode === "ok") {
          fileData.onSuccess();
          // 优先使用 fileName，如果没有则使用 retMsg
          const fileUUID = data.fileName || data.retMsg;
          _self.tenantForm.inspectionSeal = fileUUID;
          _self.inspectionSealPreviewUrl = '/api/imgs/' + fileUUID;
          appjs.showSuccessMsg("上传成功");
        } else {
          fileData.onError();
          appjs.showErrorMsg(data.retMsg || "上传失败");
        }
      }).catch((error) => {
        fileData.onError();
        appjs.showErrorMsg("异常：" + error)
      })
    },
    // 预览检测专用章
    previewInspectionSeal () {
      if (this.tenantForm.inspectionSeal) {
        this.viewFileName = this.tenantForm.inspectionSeal;
        this.isview = true;
        this.$nextTick(() => {
          if (this.$refs['pdfImgViewer']) {
            this.$refs['pdfImgViewer'].init();
          }
        });
      }
    },
    // 删除检测专用章
    removeInspectionSeal () {
      this.$confirm('确定要删除检测专用章吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tenantForm.inspectionSeal = '';
        this.inspectionSealPreviewUrl = '';
        this.$message.success('删除成功');
      }).catch(() => { });
    }
  }
}
</script>
<style scoped>
.seal-uploader {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: inline-block;
}

.seal-uploader:hover {
  border-color: #409eff;
}

.seal-upload-placeholder {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.seal-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 8px;
}

.seal-uploader-text {
  color: #606266;
  font-size: 14px;
  text-align: center;
}

.seal-preview {
  width: 150px;
  height: 150px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seal-image {
  max-width: 100%;
  max-height: 100%;
  display: block;
}

.seal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.seal-preview:hover .seal-overlay {
  opacity: 1;
}

.seal-overlay i {
  color: #fff;
  font-size: 20px;
  margin: 0 10px;
  cursor: pointer;
}

.seal-overlay i:hover {
  color: #409eff;
}
</style>
